<script setup lang="ts">
  import { EngineStore } from '~/stores/engine'
  import type { QuotedPlanVm } from '~/models/quoting/QuotedPlan'
  import { PlanCheckupStore } from '~/stores/planCheckup'

  const props = defineProps<{
    id: string
    quote: QuotedPlanVm
  }>()

  const { getId } = Id.use(props.id)

  const { flag } = FeatureFlags.use()

  const engine = EngineStore.use()
  const checkupStore = PlanCheckupStore.use()
  const emptyState = computed(() => engine.isEmptyState)

  const { quotingConfig } = QuotingConfig.use()
  const { currentSort } = QuoteUtils.useSort()

  const hideQuoteScoreThreshold = computed(
    () => flag<number>('displayed-quote-score-threshold').value
  )

  const showPlanTags = computed(
    () =>
      !quotingConfig.value.hidePlanTags &&
      !emptyState.value &&
      !(
        currentSort.value === 'healthpilot_rec' &&
        props.quote.recommendation.exists &&
        props.quote.score < hideQuoteScoreThreshold.value &&
        props.quote.medicareId !== checkupStore?.currentCheckup?.currentPlanId
      )
  )

  const carrierAepExceptions = computed(() => flag<string[]>('carrier-aep-exceptions').value)

  const aepException = computed(() =>
    carrierAepExceptions.value.includes(props.quote.details.carrierKey!)
  )
</script>

<template>
  <article class="quote-card-monthly" :id="getId()">
    <header>
      <slot name="header" v-bind="{ getId }"></slot>
    </header>
    <main class="card-content">
      <slot name="default" v-bind="{ getId, showPlanTags, aepException }"></slot>
    </main>
    <footer>
      <slot name="footer" v-bind="{ getId }"></slot>
    </footer>
  </article>
</template>

<style scoped>
  .quote-card-monthly {
    @apply flex h-full w-full flex-col gap-4 rounded-quote border border-border bg-white px-6 py-3.5;
    box-shadow: 0px 4px 12px -2px rgba(111, 114, 133, 0.2);

    & > footer {
      @apply flex w-full items-center justify-between px-2;
    }
  }
</style>
